import React from 'react'
import PropTypes from 'prop-types'

import cx from 'helpers/cx'
import { Card } from 'components'

import classes from './ProductCard.module.scss'

export const ProductCardOuter = ({
  children,
  className,
  style,
  padding,
  heavyShadow = true,
  animate = true,
  ...restProps
}) => (
  <Card
    panel
    section
    className={cx(
      classes.stackSpacing,
      heavyShadow ? classes.heavyShadow : classes.lightShadow,
      animate && (heavyShadow ? classes.animateHeavy : classes.animateLight),
      className
    )}
    style={{
      ...(padding ? { padding } : null),
      ...style,
    }}
    {...restProps}
  >
    {children}
  </Card>
)

ProductCardOuter.displayName = 'ProductCardOuter'
ProductCardOuter.propTypes = {
  animate: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  heavyShadow: PropTypes.bool,
  padding: PropTypes.string,
  style: PropTypes.object,
}

ProductCardOuter.defaultProps = {
  animate: true,
  className: undefined,
  heavyShadow: true,
  padding: undefined,
  style: undefined,
}

export default ProductCardOuter
